import { render, staticRenderFns } from "./VEmployeeProfileDocumentsBrowse.vue?vue&type=template&id=1ba899b6&lang=pug"
import script from "./VEmployeeProfileDocumentsBrowse.vue?vue&type=script&lang=ts"
export * from "./VEmployeeProfileDocumentsBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports